"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class CustomFieldController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/customField',
            edit: '/v1/customField/:objectId',
            delete: '/v1/customField/:customFieldId',
        };
    }
    deleteCustomField(customFieldId, force) {
        return this.manager.delete({
            url: `${this.endpoints.delete}${force ? '?force=true' : ''}`,
            params: {
                customFieldId,
            },
        });
    }
}
exports.default = CustomFieldController;
